import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import type { TAttentionReminderScope } from '../../../lib'
import {
  selectCockpitOffering,
  selectCockpitSelectedAttentionStatusOffering,
  selectEffectiveCockpitFYear,
} from '../../../model/selectors'

/**
 * The year and offering a reminder is about: the offering given, else the opened status' one, else
 * the cockpit's. `Overall` names no offering, so the mail and its links stand on the whole plan.
 */
export const useAttentionReminderScope = (
  offering?: string | null
): TAttentionReminderScope | undefined => {
  const fYear = useSelector(selectEffectiveCockpitFYear)
  const statusOffering = useSelector(selectCockpitSelectedAttentionStatusOffering)
  const cockpitOffering = useSelector(selectCockpitOffering)
  const programType = offering ?? statusOffering ?? cockpitOffering

  return useMemo(
    () =>
      fYear
        ? {
            fYear: Number(fYear),
            programType:
              programType && programType !== ProgramTypes.Overall ? programType : undefined,
          }
        : undefined,
    [fYear, programType]
  )
}
